import React from "react";

import styles from "./Search.module.scss";

const SearchWrapper: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.searchWrapper} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const SearchFiltersWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <SearchWrapper
    className={`${styles.searchFiltersWrapper} ${className ?? ""}`}
    {...rest}>
    {children}
  </SearchWrapper>
);

export const SearchResultsWrapper: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <SearchWrapper
    className={`${styles.searchResultsWrapper} ${className ?? ""}`}
    {...rest}>
    {children}
  </SearchWrapper>
);
